import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.laboratories' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
